import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { LoginPage } from "./login";

const routes = [
    {path: "", component: LoginPage}
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class LoginRoutingModule {}



// WEBPACK FOOTER //
// ./src/vas/pages/login/login-routing.module.ts